import dayjs from 'dayjs';

import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author Burak Ak
 */

const ResentOrders = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 70,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'orderDate',
				accessor: 'createdAt',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME,
				filterRemovable: false
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryName',
				filterType: FilterType.enumMulti,
				width: 90,
				enumName: ENUMS.DELIVERY_COMPANIES_USED,
				renderCell: ListComponents.DC_LOGO
			},
			{ Header: 'isRescheduled', accessor: 'isRescheduled', filterType: FilterType.string },
			{
				Header: 'customerPhone',
				accessor: 'telephone',
				filterType: FilterType.string,
				width: 110,
				renderCell: ListComponents.PHONE
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.multiSelection,
				width: 100,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((column) => column.accessor === 'createdAt'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(30, 'day').endOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[columns]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="resentOrders"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.ORDER_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.RESENT_ORDERS_REPORT}
				columns={columns}
				fetchUrl={REPORT.LIST.GET_RESENT_ORDERS_LIST}
				defaultSort={defaultSort}
				defaultFilters={defaultFilters}
				exportName="resentOrders"
			/>
		</div>
	);
};

export default ResentOrders;
